// BUNDLED: pdp-bundle.js
export default function() {
jQuery(function ($) {
	function featuresAndOptionsPostRender() {
		CCRZ.pubSub.trigger('updateTooltipPosition'); //update tooltip position after rerender
		checkStock();
	}

	function checkStock(initialLoad = false, callback) {
		if (!CCRZ.productDetailModel.get('stockData')) {
			CCRZ.productDetailModel.once('change:stockData',() => {
				checkStock(initialLoad, callback);
			});
			return;
		}

		let shouldUpdateViz = initialLoad;
		let inStock = CCRZ.prodDetailView.checkStock(selectedAttrObj);

		if (inStock) {
			enableAddToCart();
		} else {
			try {
				let inStockConfig = initialLoad && CCRZ.prodDetailView.findInStockConfig();
				if (inStockConfig) {
					useDefault2dImage = false;
					getPCEResponse(featureNamesToCodes(inStockConfig));
					shouldUpdateViz = false;
				} else {
					disableAddToCart('Out Of Stock', false);
				}
			} catch(err) {
				disableAddToCart('Out Of Stock', false);
			}
		}

		if (callback) {
			callback(shouldUpdateViz);
		}
	}

	function featureNamesToCodes(namesMap) {
		let feature, featureVal, codesMap = {};
		for (let featureName in namesMap) {
			feature = allFeatures.find((el) => el.name == featureName);
			featureVal = feature.featureValues.find((el) => el.name == namesMap[featureName]);
			codesMap[feature.code] = featureVal.value;
		}
		return codesMap;
	}

	CCRZ.pubSub.once('view:productDetailView:constructed', function (viewProto) {
		productType=CCRZ.productDetailModel.attributes.product.prodBean.ProductType;
		defaultImage = {
			url: CCRZ.productDetailModel.attributes.mediaWrappers['Product Image'][0].uri,
			alt: CCRZ.productDetailModel.attributes.mediaWrappers['Product Image'][0].altMessage
		}

		getProductDetails();
	});

	CCRZ.pubSub.on('view:productDetailView:refresh', function () {
		viewRendered = true;
		if (CCRZ.productDetailModel.attributes.product.prodBean.STEXPVEEnabled &&
			CCRZ.productDetailModel.attributes.mediaWrappers['2D Visualization Image'] &&
			CCRZ.productDetailModel.attributes.mediaWrappers['2D Visualization Image'][0]) {
			image2d = CCRZ.productDetailModel.attributes.mediaWrappers['2D Visualization Image'][0].uri;
			image2dUpToDate = true;
			useDefault2dImage = true;
			$('.product-details__container .image2d-target').attr('src', image2d);
			$('#2dLoadingSpinner').hide();
			$('.product-details__container .image2d-target').show();
		}
		if (haveProductDetails == false && getProductDetailsInvoked == false && CCRZ.currentUser) {
			getProductDetailsInvoked = true;
			haveProductDetails = true;
			getProductDetails();
		} else if (latestRenderData) {
			generatePageHTML(latestRenderData);
		}
		setupImageButtons();
		initializeCloudinaryVideos();
	});

	function initializeCloudinaryVideos() {
		$.each(CCRZ.productDetailModel.attributes.carouselImages, function (index, value) {
			if (document.querySelector("video#" + value.sfid) && value.mediaType === 'PDP Video') {
				try {
					const PDPPlayer = cloudinary.videoPlayer(value.sfid, JSON.parse(value.controls));
				}
				catch(err) {}
			}
		});
	}

	window.image2d = null;
	let productType = null,
		selectedAttrObj = {}, //currently selected feature name => feature val name
		selectedCodesObj = {},//currently selected feature code => feature val code
		allFeatures = [],
		image2dUpToDate = false,
		useDefault2dImage = false,
		image3d = null,
		image3dUpToDate = false,
		PCEresponse = null,
		defaultImage = null,
		catalogKey = null,
		quantity = 1,
		cartItemId = getCartItemId(),
		NOIMAGEURL = 'https://tellercms.wpengine.com/wp-content/uploads/2020/03/no-image-available.png',
		Is2DEnabled = CCRZ.pagevars.pageConfig.get("pd.ds2d").toLowerCase() === "true",
		Is3DEnabled = CCRZ.pagevars.pageConfig.get("pd.ds3d").toLowerCase() === "true",
		fees = {},
		haveProductDetails = false,
		getProductDetailsInvoked = false,
		viewRendered = false,
		latestRenderData = null,
		listPrice = null,
		sellPrice = null,
		discount = null,
		discountPrice = null,
		showAR = false,
		disableSwatchTooltip = false,
		openAccordions = [],
		initAccordionCheck = true,
		lastSelectedAttr = null,
		threekitPlayerActive = false,
		isARMode = CCRZ.getQueryParam('enableAR');

	let productDetailsCalloutActive = false,
		image2dCalloutActive = false,
		featureTooltipCalloutActive = false,
		pendingReferralCodes = null; // referral override codes not found in the cached spec (e.g. dependent features)

	function getCartItemId() {
		let urlParams = new URLSearchParams(window.location.search);
		if(urlParams.get('viewState')==='EditView') {
			return urlParams.get('cartItemId');
		} else {
			return null;
		}
	}

	function getSwatchFeatureHTML(featureData, isFirstInvalid, currentSelection) {
		let featureGroupings = {},
			showCurrentSwatch = CCRZ.productDetailModel.get('featureDisplayOptions')?.[featureData.name]?.showCurrentSwatch,
		needsSubGrouping = (isFirstInvalid) ? featureData.featureValues[1].name.includes('-') : featureData.featureValues[0].name.includes('-');
		if (needsSubGrouping) {
			$.each(featureData.featureValues, function(index, value) {
				let name = value.name.split('-')[0];
				if (value.isValid && value.image) {
					if (featureGroupings[name] == null) {
						featureGroupings[name] = [];
					}
					featureGroupings[name].push(value);
				}
			});
		}

		let optionsHTML = '';

		if (Object.keys(featureGroupings).length) {
			$.each(featureGroupings, function(featureGroupingIndex, featureGrouping) {
				$.each(featureGrouping, function(i, v) {
					optionsHTML += getSwatchHTML(featureData.code, v, featureGroupingIndex);
				});
			});
		} else {
			$.each(featureData.featureValues, function(index, value) {
				if (value.isValid != false && value.isValid != "false") {
					optionsHTML += getSwatchHTML(featureData.code, value);
				}
			});
		}

		let html = '';
		if (optionsHTML) {
			html += `<ul class="feature__options--group" role="radiogroup" tabindex="-1">
						${optionsHTML}
					</ul>`;
		}
		return `<div class="feature__swatches">${html}</div>`;
	}

	function getSwatchHTML(featureCode, featureOptionData, featureGroupingIndex) {
	let idKey = featureOptionData.value + '-' + featureCode,
		imageUrl = featureOptionData.image?.url,
		familyData = CCRZ.productDetailModel.get('fabricFamilyData')?.[featureGroupingIndex?.trim()],
		fabricName = featureOptionData.name?.split(/\((.*)\)/g)?.[0]?.split('-')[1]?.trim(),
		zoom = fabricName ? familyData?.fabricZoomValues?.[fabricName] : null;

		return `<li class="feature__option relative" role="presentation">
			<input type="radio"  role="radio" id="${idKey}" class="swatch js-option" name="${featureCode}" data-value="${featureOptionData.value}" data-group="${featureGroupingIndex || ''}"/>
			<label for="${idKey}">
				<div class="swatch__border">
					<div class="swatch__frame">
							<img loading="lazy" id="image${idKey}" src="${imageUrl ? imageUrl : ''}" alt="${featureOptionData.name}" ${zoom ? `style="zoom:${zoom}%"` : ''}/>
					</div>
				</div>
			</label>
		</li>`;

	}

	function getNonSwatchFeatureHTML(featureData) {
		let html = '';
		$.each(featureData.featureValues, function(index, value) {
			if(value.isValid != false && value.isValid != "false"){
				html += getNonSwatchOptionHTML(featureData.code, value);
			}
		});
		return html ? `<div class="feature__radio" role="radiogroup" aria-label="${featureData.name}">${html}</div>` : '';
	}

	function getNonSwatchOptionHTML(featureCode, featureOptionData) {
		if (featureOptionData.isValid == false || featureOptionData.isValid == "false") {
			return '';
		}
	let idKey = featureOptionData.value + '-' + featureCode,
		value = encodeURI(featureOptionData.name).replaceAll("'", "\\'");

		return `<input class="js-option sr-only" type="radio" name="${featureCode}" value="${value}" id="${idKey}" data-value="${featureOptionData.value}"></input>
				<label class="p pointer" for="${idKey}">
					<span>${featureOptionData.name}</span>
				</label>`;
	}

	function establishProductFeaturesHTML(featureData, featureIndex) {

		// If any feature option has an image then we assume all options have an image (ie. swatches)
		// and thus we check just the first option for image
		// We also assume that any "NOSELECT" or invalid option will always be first,
		// so check the second option if this is the case
		let isFirstInvalid = (featureData.featureValues[0].value == "NOSELECT" || !featureData.featureValues[0].isValid),
		isSwatchFeature = featureData.featureValues[0].image || (isFirstInvalid && featureData.featureValues[1].image),
		currentSelectionCode = (featureData.values && featureData.values[0]) ? featureData.values[0] : '',
		accordionOpen = openAccordions.includes(featureData.code),
		currentSelection;
		if (currentSelectionCode) {
			currentSelection = featureData.featureValues.find((el)=> el.value == currentSelectionCode);
		}
		let currentDisplayName = currentSelection?.name?.replace(` (${currentSelection.value})`, '');

		return `<li class="feature" id="feature${featureData.code}">
					<a class="feature__header ${accordionOpen ? '' : 'collapsed'}" data-toggle="collapse" href="#accordion${featureIndex}" aria-expanded="${!!accordionOpen}" aria-controls="accordion${featureIndex}">
					<div class="featureData__container">
						<div class="feature__title--container">
							<h2 class="feature__title headline-xs-120 m-0" aria-label="${featureData.name}">${featureData.name}
								<span id="featureTooltipIcon_${featureData.name.replaceAll(' ','')}" class="featureTooltipIcon" data-toggle="tooltip" style="display:none"></span>
								<span id="featureTooltipContainer_${featureData.name.replaceAll(' ','')}"></span>
							</h2>
						</div>
					</div>
						<span class="caret"></span>
					</a>
					<div class="js-accordionBody collapse ${accordionOpen ? 'in' : ''}" id="accordion${featureIndex}" data-code="${featureData.code}" role="region">
						${isSwatchFeature ? getSwatchFeatureHTML(featureData, isFirstInvalid, currentSelection) : getNonSwatchFeatureHTML(featureData)}
					</div>
				</li>`;
	}

	function establishPricingHTML() {
		sellPrice = Math.round(Math.round(sellPrice * 100) / 100); // snap to cents so float noise can't flip a .50 price
		let sellPricePrefixOverlay = "<br class='tablet-view'>";
		let configPrice = (sellPrice * quantity).toFixed(6).slice(0,-4);
		$(".js-listPrice").empty();
		$(".js-sellPrice").empty();
		$(".js-sellPrice-overlay").empty();
		$(".js-save").empty();

		let priceDisplayHTML;

		if(discount) {
			discountPrice = sellPrice;
			if (discount.type === 'Percentage') {
				discountPrice = parseFloat(sellPrice) * (1.00 - (discount.amount / 100.00));
			} else {
				discountPrice = sellPrice - discount.amount;
			}
			discountPrice = Math.floor(Math.round(discountPrice * 100) / 100); // snap to cents so float noise doesn't drop a dollar
			configPrice = (discountPrice * quantity).toFixed(6).slice(0,-4);
		}
		priceDisplayHTML = Handlebars.helpers.productPriceDisplay(CCRZ.productDetailModel.attributes.product.prodBean.name,
				getAdjustedPrice(sellPrice),
				getAdjustedPrice(discountPrice)
			)?.string;
		$(".js-sellPrice").append(`${priceDisplayHTML}`);
		$(".js-sellPrice-overlay").append(`<span>${sellPricePrefixOverlay}</span> ${priceDisplayHTML}`);
	}

	function getAdjustedPrice(price) {
		return (price) ? (Math.floor(price)) * quantity : 0;
	}

	function setSelectedFeaturesFromPCEResponse(pceResponseObj) {
		selectedAttrObj = {};
		selectedCodesObj = {};
		let featureVal;
		for (let feature of pceResponseObj.features) {
			if (feature.values?.length) {
				featureVal = feature.featureValues.find((el) => el.value == feature.values[0]);
			} else {
				featureVal = feature.featureValues.find((el) => el.isDefault);
			}
			selectedAttrObj[feature.name] = featureVal.name;
			selectedCodesObj[feature.code] = featureVal.value;
		}

		CCRZ.productDetailModel.set('selectedFeatures', selectedAttrObj);
		CCRZ.productDetailModel.set('selectedFeatureCodes', selectedCodesObj);
		CCRZ.prodDetailView.updateLeadTime();
		CCRZ.prodDetailView.updateCarbonNeutral();
	}

	function updateSelectedFeatures(featureCode, featureValueCode) {
		let newFeature = allFeatures.find((el) => el.code == featureCode);
		let newFeatureVal = newFeature?.featureValues.find((el) => el.value == featureValueCode);
		selectedAttrObj[newFeature.name] = newFeatureVal.name;
		selectedCodesObj[newFeature.code] = newFeatureVal.value;

		CCRZ.productDetailModel.set('selectedFeatures', selectedAttrObj);
		CCRZ.productDetailModel.set('selectedFeatureCodes', selectedCodesObj);
		CCRZ.prodDetailView.updateLeadTime();
		CCRZ.prodDetailView.updateCarbonNeutral();
	}

	function setSelectedFeatureInputs() {
		for (let featureCode in selectedCodesObj) {
			$(`input[name="${featureCode}"][data-value="${selectedCodesObj[featureCode]}"]`).attr('checked', true);
		}
	}

	function setupImageButtons() {
		setupSwiperSlideChangeHandler();
		attachImageButtonListeners();
	}


	function setupSwiperSlideChangeHandler() {
		// Listen for slide change event from B2C_PDPJS.js
		CCRZ.pubSub.on('pdp:swiperSlideChanged', function(data) {
			if (data.is3DSlide) {
				if (!threekitPlayerActive) {
					if (image3dUpToDate) {
						initThreekitPlayer();
					} else if (useDefault2dImage) {
						useDefault2dImage = false;
						// need to get 2d/3d if previously used default2DImage
						get2d3dFromPVE().then((data) => {
							handleSuccessful3dImageResponse(JSON.parse(data.data.Response2d.replace(/&(lt|gt|quot);/g, '"')), data.data.apiKey);
						}, handleFailedPVERequest);
					} else {
						updateVisualization();
					}
				}
			} else {
				$('#2dLoadingSpinner').hide();
			}
		});
	}

	function attachImageButtonListeners() {
		$('#ImageButtonAR').off('click');
		$('#ImageButtonAR').click((ev) => {
			if (ev.target.classList.contains('selectedImageMode')) {
				$('svg[data-id="BTN_close"]').closest('button').click();
				$('.close___qZdMz').click();
				ev.target.classList.remove('selectedImageMode');
			} else {
				$('button[data-id="arButton"]').click();
				ev.target.classList.add('selectedImageMode');
				setTimeout(() => {
					$('.modal___qvGAy').click((ev) => {
						let clickedInModal = $.contains($('.content___yNSkk')[0], ev.target);
						let closeBtn = $('.close___qZdMz')[0];
						let clickedCloseBtn = ev.target == closeBtn || $.contains(closeBtn, ev.target);
						if (clickedCloseBtn || !clickedInModal) {
							$('#ImageButtonAR').removeClass('selectedImageMode');
						}
					});
				}, 0);
			}
		});
		$('#3dInfoIcon').off('click');
		$('#3dInfoIcon').click(() => $('.threekit-help').fadeIn());
	}


	function generateFeatureTooltips(featureData,productName) {
		if(!featureTooltipCalloutActive){
			featureTooltipCalloutActive = true;
			let featureNames = [];
			$.each(featureData, function(index, value) {
				if (value.featureValues && value.featureValues.length > 1) {
					featureNames.push(value.name);
				}
			});
			const remote = _.extend(CCRZ.RemoteInvocation, { className: 'B2C_ProductDetailPageController' });
			let getFeaturesTooltips = new Promise(function (resolve, reject) {
				remote.invokeCtx('getFeatureTooltips', featureNames, productName, (res, err) => {
						featureTooltipCalloutActive = false;
						if (res && res.success) {
							resolve(res.data);
						} else {
							reject(err);
						}
					},
					{nmsp: false,
						buffer: false})
			});
			getFeaturesTooltips.then(
				function (data) {
					let decodedHTML;
					let tip;
					$.each(featureNames, function(index, featureName) {
						tip = data[featureName];
						if (tip) {
							decodedHTML = Handlebars.helpers.decodeHTML(tip.content);
							if(decodedHTML.string){
								$('#featureTooltipIcon_' + featureName.replaceAll(' ','')).tooltip({title : decodedHTML.string, placement: tip.position, html: true});
								$('#featureTooltipIcon_' + featureName.replaceAll(' ','')).show();
							}
							$('#featureTooltipIcon_' + featureName.replaceAll(' ','')).off();
							$('#featureTooltipIcon_' + featureName.replaceAll(' ','')).click('click', function(ev){
								ev.stopImmediatePropagation();
								ev.preventDefault();
								let header = `
													<button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="CCRZ.pubSub.trigger('view:B2C_Modal:closeSmall');" ></button>
													<h2 class="modal-title cc_title prodFeatureModal__head">${featureName}</h2>`;
								let body = '<div class="prodFeatureModal__body">' + Handlebars.helpers.decodeHTML(data[featureName].content).string + '</div>';
								let footer = ``;
								CCRZ.pubSub.trigger('view:B2C_Modal:openSmall', {
									header: header,
									body: body,
									footer: footer
								});
							});
						}
					});
				},
				function (error) {
					console.error('failed to get feature tooltips');
				}
			);
		}
	}

	CCRZ.pubSub.on('closeSwatchTooltip', function(){
		$('.swatch--tooltip').remove();
	});

	const carbonNeutralLabel = 'A CarbonNeutral® certified product';
	const maxTooltipWidth = 420;

	function openSwatchTooltip(PCEresponse, event){
		if (disableSwatchTooltip || !event.target.classList.contains('swatch')) {
			return;
		}

		let html = '';
		let features = JSON.parse(PCEresponse).features;
		let featureCode = event.target.name;
		let featureValue = event.target.dataset.value;
		let featureGroupingIndex = event.target.dataset.group?.trim();
		features.forEach(function(feature,index) {
			if(feature.code == featureCode) {
				feature.featureValues.forEach(function(value, index){
					if(value.value == featureValue){
						let imgUrl = value.image?.url,
						familyData = CCRZ.productDetailModel.get('fabricFamilyData')?.[featureGroupingIndex?.trim()],
						familyDesc = familyData?.description,
						familyBadges = familyData?.badges?.length && [...familyData.badges];
					let trimmedName = value.name?.replace(` (${value.value})`, '').replace(`${featureGroupingIndex} - `, '');



						$('.swatch--tooltip').remove();

						html +=
						`<div class="swatch--tooltip">
							<div class="swatch--tooltip__content">
								<div class="swatch--tooltip__nameBadge swatch--tooltip__badge small secondary ${featureGroupingIndex ? '' : 'hidden'}">${trimmedName}</div>
								<div class="${imgUrl ? 'hidden' : 'missing-img'}"></div>
								<img class="swatch--tooltip__image ${imgUrl ? '' : 'hidden'}" loading="lazy" src="${imgUrl}" alt="${value.name}"/>

								<div class="swatch--tooltip__desc">
									<h4 class="h6 swatch--tooltip__title">${featureGroupingIndex || value.name}</h4>
									<p class="small m-0 ${familyDesc ? '' : 'hidden'}">${familyDesc}</p>
									<div class="swatch--tooltip__familyBadges ${familyBadges?.length ? '' : 'hidden'}">
										${familyBadges?.reduce((badgesHtml, badgeText) => badgesHtml += `<div class="swatch--tooltip__badge small secondary">${badgeText}</div>`, '')}
									</div>
								</div>
								<div class="swatch--tooltip__desc js-carbon-neutral" style="display:none">${carbonNeutralLabel}</div>
							</div>
						</div>`;

						$('html').append(html);
						updateTooltipPosition(event);

						$(document).off('click.swatchTooltip');
						$(document).on('click.swatchTooltip', function (e) {
							e.stopPropagation();
							var container = $(".swatch--tooltip");

							if (container.has(e.target).length === 0) {
								$('.swatch--tooltip').remove();
							}

							CCRZ.pubSub.off('updateTooltipPosition');
						})

						CCRZ.pubSub.on('updateTooltipPosition', function(){
							updateTooltipPosition(event);
						});

						window.onresize = () => updateTooltipPosition(event);
					}
				});
			}
		});
	}

	function updateTooltipPosition(event) {
		let offsetTop = $(document.getElementById(event.target.id)).offset()?.top + 38;
		let offsetLeft = $('#product-details-column').offset()?.left;
		let containerWidth = $('#product-details-column').width();
		let tooltipWidth = Math.min(containerWidth, maxTooltipWidth);
		let arrowOffsetLeft = $(document.getElementById(event.target.id)).offset()?.left + 13;
		let arrowOffsetTop = offsetTop - 10;

		if((arrowOffsetLeft + 12 > offsetLeft + tooltipWidth)) { //if arrow would render outside the tooltip
			offsetLeft += containerWidth - tooltipWidth;		 //align tooltip to the right of container
		}

		$('.swatch--tooltip').offset({top:offsetTop, left:offsetLeft});
		$('.swatch--tooltip').width(tooltipWidth);
	}

	function countValidOptions(featureValues) {
		let validCount = 0;
		for(let featureValueIndex in featureValues) {
			if(featureValues[featureValueIndex].isValid) {
				validCount++;
			}
		}
		return validCount;
	}

	function shouldRenderFeature(featureData) {
		return featureData.featureValues?.length > 1 && featureData.isVisible && featureData.isEditable && countValidOptions(featureData.featureValues) > 1;
	}

	function setOpenAccordions(features) {
		openAccordions = [];
		let optionsData = CCRZ.productDetailModel.get('featureDisplayOptions');

		if (!optionsData) {
			return;
		}

		if (initAccordionCheck) {
			let collapsed;
			features.forEach((feature) => {
				collapsed = optionsData?.[feature.name] && !optionsData[feature.name].expanded;
				collapsed || openAccordions.push(feature.code);
			});
			initAccordionCheck = false;
			return;
		}

		$('.js-accordionBody').each((i, el) => {
			if (el.classList.contains('in')) {
				openAccordions.push(el.dataset?.code);
			}
		});
	}

	function generatePageHTML(data) {
		try {
			setOpenAccordions(data.features);
			$('#featuresAndOptionsDiv').html('');
			latestRenderData = data;
			$.each(data.features, function(index, value) {
				if (shouldRenderFeature(value)) {
					$('#featuresAndOptionsDiv').append(establishProductFeaturesHTML(value, index + 1));
				}
			});
			generateFeatureTooltips(data.features,data.product.name);

			if (data.features.length === 0 || (data.features.length === 1 && data.features[0].featureValues.length === 1)) {
				$('#featuresAndOptionsDiv').css('display', 'none');
			}

			if (CCRZ.headerModel.get('isWfh')) {
				let product = CCRZ.productDetailModel.get('product');
				listPrice = Math.max(getPrice(data.charges, 'List'), product.prodBean.STEXListPrice);
				sellPrice = getPrice(data.charges, 'Sell');
			} else if (productType == 'Product') {
				listPrice = getPrice(data.charges, 'List');
				sellPrice = getPrice(data.charges, 'Sell');
			}
			discount = data.discount;

			establishPricingHTML();

			$('.js-option').on('mouseenter focus', (ev) => {
				openSwatchTooltip(PCEresponse, ev)
			});

			$('.js-option').on('mouseleave blur', (ev) => {
				CCRZ.pubSub.trigger('closeSwatchTooltip')
			});

			$('.js-option').change(function(event) {
				$('#featuresAndOptionsDiv').css('pointer-events','none');
				useDefault2dImage = false;
				updateSelectedFeatures(event.target.name, event.target.dataset.value)

				if(PCEresponse) {
					if(event.target.classList.contains('swatch')){
						openSwatchTooltip(PCEresponse, event);
					}

					getPCEResponse(selectedCodesObj);
				} else {
					console.error('could not call remote action for PCE callout');
					$('#featuresAndOptionsDiv').css('pointer-events','auto');
				}
			});

			$('.js-option').on('keydown', function(event) {
				const currentRadio = $(this);
				const groupName = currentRadio.attr('name');
				const radiosInGroup = $(`input.js-option[name="${groupName}"]`);
				const index = radiosInGroup.index(currentRadio);

				if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
					event.preventDefault();
					const prevIndex = (index > 0) ? index - 1 : radiosInGroup.length - 1;
					radiosInGroup.eq(prevIndex).focus();
				} else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
					event.preventDefault();
					const nextIndex = (index < radiosInGroup.length - 1) ? index + 1 : 0;
					radiosInGroup.eq(nextIndex).focus();
				} else if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					lastSelectedAttr = currentRadio[0]?.id;
					currentRadio.prop('checked', true).change().blur();
				}
			});

			$('.js-buttonCartAdd').off("click.cartAdd");
			$(".js-buttonCartAdd").on("click.cartAdd", function(e) {
				if(e.handled !== true) {
					updateAddToCartButton(false);
					addProductToCart();
					e.handled = true;
				}
			});

			$('.js-buttonCartEdit').off("click.cartEdit");
			$('.js-buttonCartEdit').on("click.cartEdit", function(e) {
				if(e.handled !== true) {
					updateAddToCartButton(false);
					updateCartItem();
					e.handled = true;
				}
			});

			if ($(".js-detailsOverlayContainer")[0]) {
				$(window).off("scroll.overlay");
				$(window).on("scroll.overlay", function() {
					let addOrEditButton;
					if($('#addToCartButton').length === 0){
						addOrEditButton = ".js-buttonCartEdit";
					} else {
						addOrEditButton = ".js-buttonCartAdd";
					}

					let trigElement;
					let maxTop = 0;
					let overlayContainer = $(".js-detailsOverlayContainer");

					$(addOrEditButton).each(function(index, element) {

						if ($(element).offset().top > maxTop) {
							if (!($.contains(overlayContainer[0], element))) {
								maxTop = $(element).offset().top;
								trigElement = $(element);
							}
						}
					});

					if (trigElement) {
						let overlay = $(".js-detailsOverlay"),
							viewport = {
								top : $(window).scrollTop(),
								width : $(window).width()
							},
							bounds = trigElement.offset();
						viewport.bottom = viewport.top + $(window).height();
						bounds.bottom = trigElement.offset().top + trigElement.outerHeight();

						if (overlayContainer.is(":hidden") && (viewport.top > bounds.bottom)) {
							overlayContainer.show();
							if (viewport.width >= 768) {
								$(".js-detailsMedia").css("top", ("" + (90 + overlay.outerHeight()) + "px"));
							}
						} else if (!overlayContainer.is(":hidden") && !(viewport.top > bounds.bottom)) {
							overlayContainer.hide();
							if (viewport.width >= 768) {
								$(".js-detailsMedia").css("top", "90px");
							}
						}
					}
				});
			}

			let lIsValid = data.isValid;
			let lIsComplete = data.isComplete;

			if(!lIsValid || !lIsComplete || sellPrice <= 0) {
				$(".js-sellPrice").html('INVALID PRODUCT CONFIGURATION').addClass("hidden");
				$(".js-listPrice").addClass("hidden");
				$(".js-save").addClass("hidden");
				disableAddToCart('Loading...', true);
				$(".js-buttonCartAdd").addClass("hidden");
				$(".js-buttonCartEdit").addClass("hidden");
				$('#featuresAndOptionsDiv').html('<div id="featuresAndOptionsDiv"><p class="successmessage">Unable to add to cart at this time, please try again later.</p></div>');
			}  else {
				enableAddToCart();
			}
			focusLastSelectedAttr();
			showCls();
			setSelectedFeatureInputs();
			featuresAndOptionsPostRender();
		} catch (error) {
			ErrorInPage();
		}
	}

	function showCls() {
		$('.cls-show').removeClass('hidden');
		$('#productDetailsContainer').removeClass('min-height-100vh');
	}

	function focusLastSelectedAttr() {
		if (lastSelectedAttr) {
			$(`input#${lastSelectedAttr}`).focus();
			lastSelectedAttr = null;
		}
	}

	function getPrice(data, type) {
		let price = 0.0;
		$.each(data, function(index, value) {
			if(value.type == type && value.total) {
				price += value.total;
			}
		});
		price += fees.UpChargeAmount;
		return price;
	}

	function get2d3dFromPVE() {
		if (image2dCalloutActive) return Promise.reject({message: 'PVE callout already running', displayPlaceholder: false});
			const remote = _.extend(CCRZ.RemoteInvocation, { className: 'B2C_ProductDetailPageController' });
			return new Promise(function(resolve, reject) {
				if (PCEresponse && catalogKey) {
					image2dCalloutActive = true;
					remote.invokeCtx('get2DImageFromPVE', PCEresponse, catalogKey, (res, err) => {
							image2dCalloutActive = false;
							if(res && res.success) {
								resolve(res);
							} else {
								reject(err);
							}
						},
						{
							nmsp: false,
							buffer: false
						})
				} else {
					reject({message: 'invalid params for calling PVE.', displayPlaceholder: true});
				}
			});
	}

	function handleSuccessfulPVERequest(data) {
		let requestResponse = JSON.parse(data.data.Response2d.replace(/&(lt|gt|quot);/g, '"'));
		let apiKey = data.data.apiKey;
		if (!useDefault2dImage) {
			handleSuccessful2dImageRequest(requestResponse);
		}
		handleSuccessful3dImageResponse(requestResponse, apiKey);
	}

	function handleFailedPVERequest(error) {
		if (error.displayPlaceholder) {
			image2d = NOIMAGEURL;
			image2dUpToDate = true;
			image3d = NOIMAGEURL;
			image3dUpToDate = true;
			$('#productImageStatic').html('<img id="Image2d" class="js-mainProductImage" data-scale="1" style="min-height:380px;min-width:380px;" src="' + image2d + '"/>');
			$('#productImageStatic-thumb').html('<img id="Image2d-thumb" class="js-mainProductImage" data-scale="1" style="min-height:380px;min-width:380px;" src="' + image2d + '"/>');
		}
	}

	function handleSuccessful2dImageRequest(requestResponse) {
		set2dImageUrl(requestResponse.renderURL);
		enableAddToCart();
		image2dUpToDate = true;
	}

	function set2dImageUrl(renderURL) {
		image2d = renderURL;
		if (!image2d) {
			image2d = NOIMAGEURL;
			let lNoImage = true;
		} else {
			set2dImageAltText();
		}
		$('.product-details__container .image2d-target').attr('src', image2d);
		$('#2dLoadingSpinner').hide();
		$('.product-details__container .image2d-target').show();
		// Suppress auto-scroll on initial referral load so the override hero image
		// remains in view rather than jumping to the 2D render slide.
		if (CCRZ.prodDetailView.configSwiper.realIndex !== 1 && !CCRZ.referral.suppressInitialAutoSlide) {
			CCRZ.prodDetailView.configSwiper.slideToLoop(0);
		}
		CCRZ.referral.suppressInitialAutoSlide = false;
	}

	function set2dImageAltText() {
		const excludedFeatures = ['Join us in working toward better futures for people and the planet', ];

		// generate comma seperated string of features
		const featuresAltText = Object.entries(CCRZ.productDetailModel.attributes.selectedFeatures)
			.filter(([key, value]) => !excludedFeatures.includes(key))
			.map(([key, value]) => `${key}: ${value}`)
			.join(', ');

		const productName = CCRZ.productDetailModel.attributes.product.prodBean.name;

		const compiledAltText = productName + ' on a white background with ' + featuresAltText;

		$('#Image2d').attr('alt', compiledAltText);
	}

	function handleSuccessful3dImageResponse(requestResponse, apiKey){
		image3d = {requestResponse: requestResponse, apiKey: apiKey};
		image3dUpToDate = true;
		if(requestResponse.threekitScene != null){
			if (window.player) {
				B2_threeKit.updateConfiguration(requestResponse.threekitScene.buildupSpecURL);
			}
			else if (isARMode === 'true' ||
				(CCRZ.prodDetailView && CCRZ.prodDetailView.configSwiper &&
				CCRZ.prodDetailView.configSwiper.realIndex === 1)) {
				initThreekitPlayer();
			}
		}
	}

	function initThreekitPlayer() {
		let {requestResponse, apiKey} = image3d;
		if(requestResponse.threekitScene != null){
			B2_threeKit.displayThreekitScene(
				'.product-details__container #threekitContainer',
				apiKey,
				requestResponse.threekitScene.buildupAssetID,
				requestResponse.threekitScene.buildupSpecURL,
				requestResponse.threekitScene.stageAssetID,
				showAR
			);
			threekitPlayerActive = true;
		}
	}

	function getPCEResponse(selectedFeatures) {
		disableAddToCart('Updating...', true);
		if (CCRZ.productDetailModel.attributes.product.prodBean.STEXPVEEnabled) {
			B2_threeKit?.openLoadingSpinner('setConfiguration');
			$('#2dLoadingSpinner').show();
		}

		let pliId = CCRZ.detailData.priceListItemId,
			pveEnabled = CCRZ.productDetailModel.attributes.product.prodBean.STEXPVEEnabled;

		CCRZ.makeRemoteAction('B2C_ProductDetailPageController', 'getProductDetailsFromPCE', [pliId, selectedFeatures, pveEnabled]).then(
			function(data) {
				handleSuccessfulPCEResponse(data);
				if (data?.response2d) {
					handleSuccessfulPVERequest(data.response2d);
				}
			},
			function(error) {
				$('#featuresAndOptionsDiv').html('<div id="featuresAndOptionsDiv"><p class="successmessage">Unable to add to cart at this time, please try again later.</p></div>');
				$('.js-cartButton').addClass("hidden");
				$('#2dLoadingSpinner').hide();
			}
		);
	}

	function handleSuccessfulPCEResponse(data) {
		image2dUpToDate = false;
		image3dUpToDate = false;
		PCEresponse = data.pceResponse.replace(/&(lt|gt|quot);/g, '"');
		let newData = JSON.parse(PCEresponse);
		allFeatures = newData.features;
		catalogKey = newData.product.catalog.key;
		newData.discount = data.discount;

		setSelectedFeaturesFromPCEResponse(newData);

		if (viewRendered) {
			generatePageHTML(newData);
		} else {
			CCRZ.pubSub.once('view:productDetailView:refresh',()=>{
				generatePageHTML(newData);
			});
		}
	}

	function ErrorInPage(){
		$('#featuresAndOptionsDiv').html('<div id="featuresAndOptionsDiv"><p class="errorMessage">Error loading page.</p></div>');
		$('.js-cartButton').addClass("hidden");
		$('#2dLoadingSpinner').hide();
		showCls();
	}

	function getProductDetails() {
		if(!productDetailsCalloutActive){
			productDetailsCalloutActive = true;
			CCRZ.makeRemoteAction('B2C_ProductDetailPageController', 'getProductDetails', [CCRZ.detailData.priceListItemId, cartItemId]).then(
				function(data) {
					productDetailsCalloutActive = false;
					handleSuccessfulGetProductDetails(data);
					getProductDetailsInvoked = true;
				},
				function(error) {
					haveProductDetails = false;
					getProductDetailsInvoked = false;
				}
			);
		}
	}

	function handleSuccessfulGetProductDetails(data) {
		showAR = data.showAR;
		fees.UpChargeAmount = data.upchargeAmount || 0;

		if(cartItemId && data.existingCartItem?.selectedAttributes) {
			quantity = data.existingCartItem.quantity || 1;
			useDefault2dImage = false;
			getPCEResponse(JSON.parse(data.existingCartItem.selectedAttributes));
		} else if (data.pceResponse) {

			if (CCRZ.referral.isValidAndStored()) {
				data.pceResponse = injectReferralData(data.pceResponse);
				useDefault2dImage = false;
				// Prevent the 2D image loading from auto-scrolling the carousel away from
				// the referral hero image on initial page load.
				CCRZ.referral.suppressInitialAutoSlide = true;
			}

		handleSuccessfulPCEResponse(data);

			// If some referral feature codes couldn't be injected into the cached spec
			// make a live PCE call with the full referral code set merged in.
			if (pendingReferralCodes && Object.keys(pendingReferralCodes).length > 0) {
				let codesForLiveCall = Object.assign({}, selectedCodesObj, pendingReferralCodes);
				pendingReferralCodes = null; // clear to prevent repeat calls
				getPCEResponse(codesForLiveCall);
			} else {
				checkStock(true, (shouldUpdateViz) => {
					if(shouldUpdateViz) {
						updateVisualization();
					}
				});
			}
		}

	}

	function updateVisualization() {
		if (CCRZ.productDetailModel.attributes.product.prodBean.STEXPVEEnabled) {
			if (useDefault2dImage) {
				set2dImageAltText();
				image2dUpToDate = true;
				return;
			}

			if (!PCEresponse) {
				getProductDetails();
			} else {
				get2d3dFromPVE().then(handleSuccessfulPVERequest, handleFailedPVERequest);
			}
		} else {
			$('#2dLoadingSpinner').hide();
		}
	}

	function animateCartMessage(messageText, isError = false) {
		let messageContainer = $('#cartAddMessages');
		messageContainer.empty();
		messageContainer.height(0);
		messageContainer.append(`<div class="${isError ? 'errorMessage' : 'successmessage'} message">${messageText}</p>`);
		messageContainer.height($('#cartAddMessages .message').outerHeight(true));

		setTimeout(function() {
			$('#cartAddMessages .message').fadeOut(5000, () => messageContainer.height(0));
		}, 1000);
	}

	function handleSuccessfulCartAdd(data) {
		CCRZ.pagevars.currentCartID = data.cartId;
		animateCartMessage('Successfully added item to cart');
		updateAddToCartButton(true);
	}

	function handleFailedCartAdd() {
		animateCartMessage('Unable to add to cart at this time, please try again later', true);
		updateAddToCartButton(true);
	}

	/////*** COMMON METHOD FOR ADD TO CART FOR ALL PRODUCT TYPES ***/////
	function addProductToCart() {
		let productId = CCRZ.productDetailModel.get('product').prodBean.id,
			defaultImg = defaultImage.url || CCRZ.productDetailModel.attributes.mediaWrappers['Product Image'][0].uri,
			pveEnabled = CCRZ.productDetailModel.attributes.product.prodBean.STEXPVEEnabled,
			imageUrl = (pveEnabled && image2d) ?  image2d : defaultImg,
			leadTime = CCRZ.productDetailModel.get('currentLeadTime') ? CCRZ.productDetailModel.get('currentLeadTime') : CCRZ.productDetailModel.attributes.product.prodBean.leadTime;
		const params = {
			'productId' : productId,
			'quantity' : quantity,
			'imageUrl' : imageUrl,
			'selectedFeaturesMap' : selectedCodesObj,
			'leadTime' : leadTime,
			'algoliaQueryId': CCRZ.pagevars.queryParams.qid
		}
		B2C_CartUtilities.addToCart(params, handleSuccessfulCartAdd, handleFailedCartAdd);
	}

	function updateCartItem() {
		let productId = CCRZ.productDetailModel.get('product').prodBean.id,
			defaultImg = defaultImage.url || CCRZ.productDetailModel.attributes.mediaWrappers['Product Image'][0].uri,
			pveEnabled = CCRZ.productDetailModel.attributes.product.prodBean.STEXPVEEnabled,
			imageUrl = (pveEnabled && image2d) ?  image2d : defaultImg,
			leadTime = CCRZ.productDetailModel.get('currentLeadTime') ? CCRZ.productDetailModel.get('currentLeadTime') : CCRZ.productDetailModel.attributes.product.prodBean.leadTime;
		const params = {
			'productId' : productId,
			'quantity' : quantity,
			'imageUrl' : imageUrl,
			'cartItemId': cartItemId,
			'selectedFeaturesMap' : selectedCodesObj,
			'leadTime' : leadTime
		};
		B2C_CartUtilities.addToCart(params, handleSuccessfulCartUpdate, handleFailedCartUpdate, false);
	}

	function updateAddToCartButton(pIsPostAdd) {
		if(pIsPostAdd) {
			enableAddToCart();
		} else {
			disableAddToCart('Updating...', true);
			$('#featuresAndOptionsDiv').css('pointer-events','none');
		}
	}

	function disableAddToCart(buttonText, useProgressCursor){
		if(useProgressCursor) {
			$("body").css("cursor", "progress");
		}
		$(".js-buttonCartAdd").text(buttonText);
		$(".js-buttonCartAdd").attr('aria-label', 'Add to cart button disabled');
		$(".js-buttonCartAdd").prop('disabled', true);
		$(".js-buttonCartEdit").text(buttonText);
		$(".js-buttonCartEdit").attr('aria-label', 'Add to cart button disabled');
		$(".js-buttonCartEdit").prop('disabled', true);
	}

	function enableAddToCart() {
		$("body").css("cursor", "default");
		if(CCRZ.prodDetailView.isInStock) {
			$(".js-buttonCartAdd").text('Add to Cart');
			$(".js-buttonCartAdd").attr('aria-label', 'Add to cart button');
			$(".js-buttonCartAdd").prop('disabled', false);
			$(".js-buttonCartEdit").text('Update')
			$(".js-buttonCartEdit").attr('aria-label', 'Add to cart button');
			$(".js-buttonCartEdit").prop('disabled', false);
		}
		$('#featuresAndOptionsDiv').css('pointer-events','auto');
	}

	function handleSuccessfulCartUpdate(data) {
		$('#messagesDiv').empty();
		setTimeout(function() {
			$('#cartAddMessages').append('<div class="successmessage">Successfully updated item to cart</p>');
			$('.successmessage').fadeOut(5000);
		}, 1000);

		let currURL = window.location.href;
		currURL = currURL.replace('ccrz__ProductDetails','ccrz__Cart');

		currURL= currURL.replace(/(sku=).*?(&)/,'');
		currURL = currURL.split('&cartItemId=')[0];
		window.location.href = B2C_UrlUtility.verifyRedirectUrl(currURL);
	}

	function handleFailedCartUpdate() {
		setTimeout(function() {
			$('#cartAddMessages').append('<div class="errorMessage">Could not update item to cart.</p>');
			$('.errorMessage').fadeOut(5000);
		}, 1000);
		updateAddToCartButton(true);
	}

	// Injects referral data into cached default PCE configuration.
	// Applies feature value overrides and recalculates price deltas against the default selected values.
	// Features absent from the cached spec (e.g. dependent features only available after another selection)
	// are tracked in pendingReferralCodes for a follow-up live PCE call.
	function injectReferralData(data) {
		let referralData = CCRZ.productDetailModel.get('referralOptions')?.[sessionStorage.getItem('referralCode')];
		if (!referralData || !data) return data;

		// Start with all configured codes as pending; remove each one as it is successfully applied.
		pendingReferralCodes = Object.assign({}, referralData.features);

		data = JSON.parse(data.replace(/&(lt|gt|quot);/g, '"'));
		let appliedOverrides = 0;

		data?.features?.forEach(pceFeature => {
			let newValueCode = referralData.features?.[pceFeature?.code];
			if (!newValueCode) return; // no override configured for this feature

			// Verify the target feature value actually exists in the PCE response before applying.
			let newFeatureVal = pceFeature.featureValues?.find(val => val.value === newValueCode);
			if (!newFeatureVal) {
				// Feature is in the spec but the value is not valid for the default config.
				// Leave it in pendingReferralCodes so a live PCE call can apply it.
				console.warn(`[Referral] Feature value "${newValueCode}" not found for feature "${pceFeature.code}". Queuing for live PCE call.`);
				return;
			}

			// Subtract the currently selected (default) feature value's charges, then add the new one's.
			// This computes the correct price delta rather than blindly adding the new charge.
			let currentValueCode = pceFeature.values?.[0];
			let currentFeatureVal = pceFeature.featureValues?.find(val => val.value === currentValueCode);
			currentFeatureVal?.charges?.forEach(charge => {
				let productCharge = data.charges?.find(c => c.type === charge.type);
				if (productCharge) productCharge.total -= charge.total;
			});

			// Add the referral feature value's charges.
			newFeatureVal.charges?.forEach(charge => {
				let productCharge = data.charges?.find(c => c.type === charge.type);
				if (productCharge) productCharge.total += charge.total;
			});

			pceFeature.values = [newValueCode];
			delete pendingReferralCodes[pceFeature.code]; // mark as applied
			appliedOverrides++;
		});

		if (appliedOverrides === 0) {
			console.warn('[Referral] No valid feature overrides could be applied from cached spec. A live PCE call will be made.');
		}

		return JSON.stringify(data);
	}
});

// Referral code utilities - namespaced on CCRZ to avoid polluting global scope.
// Used by both B2C_PDPFeaturesAndOptions.js and B2C_PDPJS.js.
CCRZ.referral = {
	// Returns true if a referral code is present and matches an active override for this product.
	isValidAndStored: function() {
		// Store URL param immediately, before any validation.
		let params = new URLSearchParams(window.location.search);
		let urlCode = params.get('referralCode');
		if (urlCode) {
			sessionStorage.setItem('referralCode', urlCode);
		}

		let refCode = urlCode || sessionStorage.getItem('referralCode');
		if (!refCode) return false;

		if (!_.has(CCRZ.detailData?.referralOptions, refCode)) return false;

		// Re-add the URL param if navigating back without it.
		if (!urlCode) {
			let currentParams = new URLSearchParams(window.location.search);
			currentParams.set('referralCode', refCode);
			history.replaceState(null, '', window.location.pathname + '?' + currentParams.toString());
		}
		return true;
	}
};
}
